import React, { useEffect, useRef } from "react";
import { Container, Table, Button, Spinner, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAlertsByUser,
  acknowledgeAlertById,
} from "../../redux/slices/AlertSlice";
import NavbarComponent from "./SenseNavBar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import "./UserCSS/custom.css";

function UserAlerts() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Redux state
  const alerts = useSelector((state) => state.alerts.alerts);
  const loading = useSelector((state) => state.alerts.loading);
  const user = useSelector((state) => state.auth.user);
  const initialized = useRef(false);

  // Fetch alerts on mount and when user changes
  useEffect(() => {
    if (user) {
      console.log("Dispatching fetchAlertsByUser with user_id:", user.user_id); // Debug
      dispatch(fetchAlertsByUser(user.user_id));
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (alerts.length > 0 && !initialized.current) {
      initialized.current = true;
    }
  }, [alerts]);

  const handleAcknowledge = (alertId) => {
    dispatch(acknowledgeAlertById(alertId));
  };

  const handleBackToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="dashboard-wrapper">
      <NavbarComponent />
      <Container
        fluid
        className="dashboard-content"
        style={{ minHeight: "60vh" }}
      >
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <h2 className="text-center mb-4" style={{ fontWeight: "bold" }}>
              Patient Help Alerts
            </h2>
            <Button variant="secondary" onClick={handleBackToDashboard}>
              Back
            </Button>
          </Col>
        </Row>
        {!initialized.current && loading ? (
          <div className="text-center">
            <Spinner animation="grow" variant="primary" />
            <p>Loading alerts...</p>
          </div>
        ) : (
          <Row className="justify-content-center mt-4">
            <Col md={10} lg={8}>
              <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th>Patient ID</th>
                      <th>Alert Content</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {alerts && alerts.length > 0 ? (
                      alerts.map((alert) => (
                        <tr key={alert.id}>
                          <td>{new Date(alert.time).toLocaleString()}</td>
                          <td>{alert.patient_id}</td>
                          <td>{alert.alert_content}</td>
                          <td>{alert.acknowledged ? "Acknowledged" : "New"}</td>
                          <td>
                            {!alert.acknowledged ? (
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => handleAcknowledge(alert.id)}
                              >
                                Acknowledge
                              </Button>
                            ) : (
                              <span
                                style={{ color: "green", fontWeight: "bold" }}
                              >
                                &#10003; {/* checkmark */}
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No alerts found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        )}
      </Container>
      <Footer />
    </div>
  );
}

export default UserAlerts;
